import { SxProps } from '../../theme';
import { AvatarSizeBreakpoint, AvatarSizeProp, sizeBreakpoints } from './types';
import { AvatarTokens } from './const';

export const getAvatarSizeStyles = (): SxProps => {
  return {
    height: AvatarTokens.Size('100px'),
    maxHeight: AvatarTokens.Size('100px'),
    maxWidth: AvatarTokens.Size('100px'),
    width: AvatarTokens.Size('100px'),
  };
};

const normalizeSizeValue = (value: number | string): string => (typeof value === 'number' ? `${value}px` : value);

export const getAvatarSizeTokenStyles = (size: AvatarSizeProp): SxProps => {
  if (typeof size === 'object') {
    const result: Record<string, unknown> = {};
    for (const bp of sizeBreakpoints) {
      const bpKey = bp as AvatarSizeBreakpoint;
      if (bpKey in size) {
        result[bp] = { [AvatarTokens.Size]: normalizeSizeValue(size[bpKey]) };
      }
    }
    return result as SxProps;
  }

  return { [AvatarTokens.Size]: normalizeSizeValue(size) };
};
